export default {
  candidateComments: [],
  candidateComment: undefined,
};
